// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","activeCard":"Card_activeCard__6jVYZ","activeCardOverlay":"Card_activeCardOverlay__v6Xnt"};